import { CellEditingStartedEvent } from 'ag-grid-community';

const useInstantEditPlugin = () => {
	// when the keystroke is alphanumeric and the cell is being edited, we simulate the keypress
	// to the input element to make it feel like the user is typing directly into the cell
	const onCellEditingStarted = (e: CellEditingStartedEvent) => {
		if (
			e.event instanceof KeyboardEvent
      && document.activeElement instanceof HTMLInputElement
      && /^[a-z0-9]+$/i.test(e.event.key)
      && e.event.key.length === 1
		) {
			const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
				window.HTMLInputElement.prototype,
				'value',
			)?.set;

			nativeInputValueSetter?.call(document.activeElement, e.event?.key);
			document.activeElement?.dispatchEvent(new Event('input', { bubbles: true }));
		}
	};

	return { onCellEditingStarted };
};

export default useInstantEditPlugin;
